import type {ReactElement} from 'react';
import {useContext} from 'react';
import {formMakerContext} from '@FormMakerReact/form-maker.context';
import {TogglerTab} from './components/toggler-tab/toggler-tab';
import {FORM_TOGGLER_VIEWS} from './form-maker-form-toggler.types';
import styles from './form-maker-form-toggler.module.scss';

export function FormMakerFormToggler(): ReactElement {
  const {state, actions} = useContext(formMakerContext);
  if (state.isEditorLoading) {
    return renderLoading();
  }
  const activeMode = state.formMode;
  return (
    <div className={styles.toggler} role="radiogroup">
      {FORM_TOGGLER_VIEWS.map(({mode, icon, labelKey}) => (
        <TogglerTab
          key={mode}
          isActive={activeMode === mode}
          icon={icon}
          label={window.i18next.t(labelKey)}
          onClick={(): void => {
            actions.setFormMode(mode);
          }}
        />
      ))}
    </div>
  );
}

function renderLoading(): ReactElement {
  return <div className={styles.skeleton} aria-hidden />;
}
